import { RootState } from "app/store";
import { selectScorable } from "../scorableSlice";

export const selectIsSystemSubmitted = (state: RootState) => {
    const scorable = selectScorable(state);
    return scorable?.systemSubmitted ?? false;
};
